<template>
  <TheNavbar />

  <div class="mt-5 mb-5">

    <div class="row justify-content-center g-3">

      <div class="col-12 text-center">
        <h3>SIGNUM Strategies</h3>
        <p>You have full access to these strategies, while you have an active SIGNUM account (active trial or active subscription). When your account becomes inactive, you automatically lose access to these strategies.</p>
      </div>

      <div v-if="!userHasAccessToStrategiesMix" class="col-12">
        <div class="alert alert-warning border-0 d-flex align-items-center" role="alert">
          <div class="bg-warning me-3 icon-item"><span class="fas fa-exclamation-circle text-white fs-6"></span></div>
          <p class="mb-0 flex-1">
            <span class="fw-bold">You don't have access to the SIGNUM Strategies anymore </span><br>
            Your access is free for the first 60 days after you've signed up or during your trial period, which is 14 days after the 1st trade you've made. Both have expired in your case.<br>
            <br>
            Subscribe now to regain access:<br>
            <router-link :to="{name: 'Subscription', params: {}}" class="btn btn-primary btn-sm mt-1" type="button">
              Subscribe Now
            </router-link>
          </p>
        </div>
      </div>

      <!-- SIGNUM Strategies (non-exclusive) -->
      <div v-for="strategy in signumStrategies" :key="strategy.name" class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6" :class="userHasAccessToStrategiesMix ? 'opacity-100' : 'opacity-25'">
        <div class="card h-100">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">{{ strategy.tradingViewName }}</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary">
            <img v-if="getStrategyImage(strategy.name)" class="img-fluid rounded mx-auto mb-3" :src="getStrategyImage(strategy.name)" />

            <p>
              This strategy is private. You can get access to it by clicking on "Get Access" below.
            </p>

            <div class="text-center">
              <a class="btn btn-primary btn-sm" type="button" :href="strategy.tradingViewUrl" target="_blank">
                Open in TradingView <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-0"></span>
              </a>
              &nbsp;

              <router-link v-if="userHasAccessToStrategiesMix" :to="{name: 'StrategyDetail', params: { strategyName: strategy.name }}" class="btn btn-primary btn-sm" type="button" href="">
                Get Access
              </router-link>
              <a v-if="!userHasAccessToStrategiesMix" class="btn btn-primary btn-sm" type="button"> Get Access </a>
            </div>
          </div>
        </div> <!-- card-->
      </div> <!-- col-->

      <!-- ATX Strategies (exclusive for AutoTrading members) -->
      <div v-if="userHasAccessToAtxStrategiesMix && atxStrategies.length > 0" class="col-12 text-center mt-5">
        <h3>AutoTrading-Extra Strategies</h3>
        <p>These strategies are only accessible for AutoTrading members. Those are variantes Michael has coded but not deemd "better" than what is already in the AutoTrading Masterclass. You'll also find strategies made from famous and well known indicators. Enjoy </p>
      </div>

      <template v-if="userHasAccessToAtxStrategiesMix">
        <div v-for="strategy in atxStrategies" :key="strategy.name" class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
          <div class="card h-100">
            <div class="card-header">
              <div class="row flex-between-end">
                <div class="col-auto text-center">
                  <h5 class="mb-0" data-anchor="data-anchor">{{ strategy.tradingViewName }}</h5>
                </div>
              </div>
            </div>
            <div class="card-body bg-body-tertiary">
              <img v-if="getStrategyImage(strategy.name)" class="img-fluid rounded mx-auto mb-3" :src="getStrategyImage(strategy.name)" />

              <p>
                This strategy is private. You can get access to it by clicking on "Get Access" below.
              </p>

              <div class="text-center">
                <a class="btn btn-primary btn-sm" type="button" :href="strategy.tradingViewUrl" target="_blank">
                  Open in TradingView <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-0"></span>
                </a>
                &nbsp;

                <router-link :to="{name: 'StrategyDetail', params: { strategyName: strategy.name }}" class="btn btn-primary btn-sm" type="button" href="">
                  Get Access
                </router-link>
              </div>

            </div>
          </div> <!-- card-->
        </div> <!-- col-->
      </template>
      
      <div class="col-12 text-center mt-5">
        <h3>Help & Education</h3>
      </div>

      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">How to use these strategies?</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary">
            <img class="img-fluid rounded" style="max-height: 40px;" src="@/assets/strategies/open_tv_strategy.jpg" />
            <p>
              Open the strategy you want to use.
            </p>

            <img class="img-fluid rounded" style="max-height: 40px;" src="@/assets/strategies/add_to_fav.jpg" />
            <p>
              Scroll down and add the strategy to your favorites.
            </p>

            <img class="img-fluid rounded mx-auto" src="@/assets/strategies/tv_indicators.jpg" />
            <p>
              <a href="https://www.tradingview.com/chart/" target="_blank">Go to TradingView <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-0"></span></a> and open the <span class="fw-bold">Indicators</span> menu.<br>
              Click on the strategies you want to add to your chart (click once per strategy).<br>
              <br>
              Now go to the <router-link :to="{name: 'MyBots', params: {}}" class="" href="">SIGNUM Bot</router-link> that you want to use (or create one) and follow the instructions there :)
            </p>


          </div>
        </div> <!-- card-->
      </div> <!-- col-->

      <div class="col-sm-12 col-md-10 col-lg-8 col-xl-8 col-xxl-6">
        <div class="card">
          <div class="card-header">
            <div class="row flex-between-end">
              <div class="col-auto text-center">
                <h5 class="mb-0" data-anchor="data-anchor">AutoTrading Masterclass</h5>
              </div>
            </div>
          </div>
          <div class="card-body bg-body-tertiary">
            <img class="img-fluid rounded mx-auto mb-3" src="@/assets/strategies/at_course_cover.jpg" />

            <p>
              Learn how to automate your Bitcoin & Crypto investments with algo trading strategies. Become a master in risk & portfolio management and trade automation.<br>
              Get access to the AutoTrading trading strategies, the community and 12 months free SIGNUM access.
            </p>

            <div class="text-center">
              <a class="btn btn-primary btn-sm" type="button" href="https://autotrading.vip" target="_blank">
                Learn More <span class="fas fa-external-link-alt" data-fa-transform="shrink-3 down-0"></span>
              </a>
            </div>
          </div>
        </div> <!-- card-->
      </div> <!-- col-->

    </div>

  </div>
</template>

<script>
import TheNavbar from '@/components/TheNavbar'
import { userHelperMixin } from '@/mixins/userHelperMixin'

export default {
  mixins: [userHelperMixin],
  components: {
    TheNavbar
  },
  computed: {
    strategies () {
      const strategies = this.$store.getters.getStrategies
      
      // Avoiding race condition when re-loading the page
      if (strategies)
        return Object.values(strategies).filter(s => s.name != 'GAUSSIAN_CHANNEL_PRO') // Decided to hide GAUSSIAN_CHANNEL_PRO
      
      return null
    },
    signumStrategies () {
      if (!this.strategies) return []
      return Object.values(this.strategies).filter(s => !s.isExclusiveForAutoTrading)
    },
    atxStrategies () {
      if (!this.strategies) return []
      return Object.values(this.strategies).filter(s => s.isExclusiveForAutoTrading)
    },
    getSupportUrl () {
      return process.env.VUE_APP_SUPPORT_URL
    }
  },
  methods: {
    getStrategyImage (strategyName) {
      try {
        return require('@/assets/strategies/' + strategyName + '.png')
      } catch (e) {
        return null
      }
    }
  },
  async created () {
    if (!this.$store.getters.getUserBots) await this.$store.dispatch('getUserBots')
    if (!this.$store.getters.getStrategies) await this.$store.dispatch('getStrategies')
  },
  beforeMount () {
    // Redirect to Login when the user is not logged in
    if (!this.$store.getters.isUserLoggedIn) this.$router.push({ name: 'Login' })
  }

}
</script>
